{
  "$schema": "https://assets.gtx.dev/config-schema.json",
  "defaultLocale": "en-GB",
  "locales": ["en-GB", "nl-NL", "de-DE", "fr-FR"]
}
